<template>
  <!-- 5-1 管理员-医疗机关查看列表ー点看详情-->
  <div class="main-box">
    <div class="main-box-all-css">
      <!-- 主要内容部分 -->
      <div class="main-box-css">
        <!-- 左边表单部分 -->
        <div class="left-box">
          <!-- 第一行 -->
          <div class="one-line">
            <div class="avatar">
              <img
                :src="img"
                alt=""
                @error="
                  e => {
                    e.target.src = require('@/assets/defaultImg.png');
                  }
                "
              />
            </div>
            <div class="institution-name">
              <div class="institution-box">
                <div class="institution-title">{{ $t("certified") }}</div>
                <span>{{ $t("institutionName") }}</span>
                <el-tooltip :content="institutionName" placement="top">
                  <p class="institution-main">
                    {{ institutionName }}
                  </p></el-tooltip
                >
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("postCode") }}</span>
              <el-tooltip :content="postCode" placement="top">
                <p class="small-box-title">{{ postCode }}</p></el-tooltip
              >
            </div>
            <div class="big-input-box">
              <span>{{ $t("location") }}</span>
              <el-tooltip :content="area" placement="top">
                <p class="small-box-title">{{ area }}</p></el-tooltip
              >
            </div>
          </div>
          <!-- 第三行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("institutionalAttributes") }}</span>
              <el-tooltip
                :content="
                  language === 'CN'
                    ? msgList.attributes_dictText
                    : msgList.jpattributes_dictText
                "
                placement="top"
              >
                <p class="small-box-title" v-if="language === 'CN'">
                  {{ msgList.attributes_dictText }}
                </p>
                <p class="small-box-title" v-if="language === 'JP'">
                  {{ msgList.jpattributes_dictText }}
                </p></el-tooltip
              >
            </div>
            <div class="big-input-box">
              <span>HP or SNS</span>
              <el-tooltip :content="hPorSNS" placement="top">
                <p class="small-box-title">{{ hPorSNS }}</p></el-tooltip
              >
            </div>
          </div>
          <!-- 第四行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("representativeName") }}</span>
              <el-tooltip :content="representativeName" placement="top">
                <p class="small-box-title">
                  {{ representativeName }}
                </p></el-tooltip
              >
            </div>
            <div class="big-input-box">
              <span>{{ $t("institutionalNumber") }}</span>
              <el-tooltip :content="phoneNumber" placement="top">
                <p class="small-box-title">{{ phoneNumber }}</p></el-tooltip
              >
            </div>
          </div>
          <!-- 第五行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("registeredCapital") }}</span>
              <el-tooltip
                :content="
                  language === 'CN'
                    ? msgList.capitalAmount_dictText
                    : msgList.jpcapitalAmount_dictText
                "
                placement="top"
              >
                <p class="small-box-title" v-if="language === 'CN'">
                  {{ msgList.capitalAmount_dictText }}
                </p>
                <p class="small-box-title" v-if="language === 'JP'">
                  {{ msgList.jpcapitalAmount_dictText }}
                </p>
              </el-tooltip>

              <!-- <p class="small-box-title">{{ capital }}</p> -->
            </div>
            <div class="small-dropdown">
              <span>{{ $t("numberOfEmployees") }}</span>
              <el-tooltip
                :content="
                  language === 'CN'
                    ? msgList.employeeNumber_dictText
                    : msgList.jpemployeeNumber_dictText
                "
                placement="top"
              >
                <p class="small-box-title" v-if="language === 'CN'">
                  {{ msgList.employeeNumber_dictText }}
                </p>
                <p class="small-box-title" v-if="language === 'JP'">
                  {{ msgList.jpemployeeNumber_dictText }}
                </p>
              </el-tooltip>
            </div>
            <div class="small-dropdown">
              <span>{{ $t("numberOfBets") }}</span>
              <el-tooltip
                :content="
                  language === 'CN'
                    ? msgList.bedNumber_dictText
                    : msgList.jpbedNumber_dictText
                "
                placement="top"
              >
                <p class="small-box-title" v-if="language === 'CN'">
                  {{ msgList.bedNumber_dictText }}
                </p>
                <p class="small-box-title" v-if="language === 'JP'">
                  {{ msgList.jpbedNumber_dictText }}
                </p>
              </el-tooltip>
            </div>
          </div>
          <!-- 第六行 -->
          <div class="textarea-line">
            <div class="textarea-line-box">
              <span>{{ $t("businessContent") }}</span>
              <p class="textarea-css-main">{{ textData }}</p>
            </div>
          </div>
          <!--第七行-->
          <!-- <div class="two-line">
            <div class="small-input-box" style="margin-left: 40px">
              <span>{{ $t("registeredCapital") }}</span>
              <p class="small-box-title">{{ capital }}</p>
            </div>
            <div class="small-dropdown">
              <span>{{ $t("numberOfEmployees") }}</span>
              <p class="small-box-title">{{ numberEmployees }}</p>
            </div>
            <div class="small-dropdown" style="margin-right: 40px">
              <span>{{ $t("numberOfBets") }}</span>
              <p class="small-box-title">{{ numberBets }}</p>
            </div>
          </div> -->
        </div>
        <!-- 右边表格部分 -->
        <div class="right-box">
          <el-table
            :data="tableData"
            style="width: 100%"
            max-height="560px"
            min-height="350px"
            @sort-change="changeTableSort"
            @selection-change="duoxuan"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="jobName"
              label="案件名"
              min-width="120"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("caseName") }}</p>
                <!-- <el-input
                  v-model="tableSearch1"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
            </el-table-column>
            <el-table-column prop="workSpace" label="勤務地" width="100">
              <template slot="header">
                <p>{{ $t("workLocation") }}</p>
                <!-- <el-input
                  v-model="tableSearch2"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="掲載日"
              min-width="100"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("payonTheDay") }}</p>
                <!-- <el-input
                  v-model="tableSearch3"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="visitedTime"
              label="観覧回数"
              :sortable="'custom'"
            >
              <template slot="header">
                <p class="empty-ps">{{ $t("numberOfVisits") }}</p>
                <!-- <p class="empty"></p> -->
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页部分 -->
          <div class="pagination-table">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="tableSize"
              layout=" prev, pager, next"
              :total="total"
            >
            </el-pagination>
            <span class="per-page">Rows per page</span>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ tableSize }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">5</el-dropdown-item>
                <el-dropdown-item command="b">10</el-dropdown-item>
                <el-dropdown-item command="c">15</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- button 部分 -->
      <div class="line-button-box">
        <button class="button-css2" @click="peopleView">
          {{ $t("peopleView") }}
        </button>
        <button class="button-css2" @click="collectionInserts">
          {{ $t("collection") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryMedicalInstitutionDetailInfo,
  medicalInstitutionDetailsQuery,
  getUrlFromOSS,
  collectionInsert
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalInstitutionInformation",
  components: {},
  data() {
    return {
      medicalId: "",
      institutionName: "", //機関名
      postCode: "", //郵便番号
      area: "", //所在地
      agencyAttribute: "", //機関属性
      hPorSNS: "", //HP or SNS
      representativeName: "", //代表者氏名
      phoneNumber: "", //機関の電話番号
      numberEmployees: "", //授業員数
      numberBets: "", //ベット数
      capital: "", //資本金
      textData: "", //事业内容
      frequency: "", //職員数
      tableSearch1: "", //table案件名
      tableSearch2: "", //table勤務地
      tableSearch3: "", //table掲載日
      tableData: [], //table数据内容
      tableSize: 5,
      currentPage: 1,
      pageSize: 5,
      total: 0,
      avatarAddress: "",
      img: "",
      language: "",
      msgList: {}
    };
  },
  created() {
    this.language = window.localStorage.getItem("language");
    this.getList();
    this.getlist1();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.getList();
        this.getlist1();
      }
    },
    //接口 获取表格数据
    getList() {
      console.log(this.$route.query.medicalId);
      console.log(this.$route.query.userId);
      this.medicalId = this.$route.query.medicalId;
      //左侧数据获取
      var fakeInfo = {
        medicalId: this.$route.query.medicalId,
        pageNumber: 1,
        pageSize: 7
      };
      queryMedicalInstitutionDetailInfo(fakeInfo)
        .then(res => {
          console.log("--------管理员查询医疗机构详细信息接口1--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalItem = aesFecInfo.data[0].total;
            this.msgList = aesFecInfo.data[0];
            this.institutionName = aesFecInfo.data[0].medicalName; //機関名
            this.postCode = aesFecInfo.data[0].postNumber; //郵便番号
            this.area = aesFecInfo.data[0].address; //所在地
            this.agencyAttribute = aesFecInfo.data[0].attributes; //機関属性
            this.hPorSNS = aesFecInfo.data[0].hpOrSns; //HP or SNS
            this.representativeName = aesFecInfo.data[0].legalPerson; //代表者氏名
            this.phoneNumber = aesFecInfo.data[0].telephone; //機関の電話番号
            this.capital = aesFecInfo.data[0].capitalAmount; //資本金
            this.frequency = aesFecInfo.data[0].employeeNumber_dictText; //職員数
            this.numberBets = aesFecInfo.data[0].bedNumber; //ベット数
            this.textData = aesFecInfo.data[0].introduction; //事業内容
            this.numberEmployees = aesFecInfo.data[0].employeeNumber; //
            this.getUrl(aesFecInfo.data[0].avatarAddress);
            console.log("链接成功");
          } else {
            this.$message.error("登录失败。");
          }
        })
        .catch(res => {});
    },
    getlist1() {
      //右侧数据获取
      console.log("--------右侧列表数据获取--------");
      var fakeInfo2 = {
        medicalId: this.$route.query.medicalId,
        pageNumber: this.currentPage,
        pageSize: this.tableSize
      };
      medicalInstitutionDetailsQuery(fakeInfo2)
        .then(res2 => {
          console.log("--------右侧列表数据获取--------");
          console.log(res2);
          if (res2.data.code === "A0000") {
            const aesFecInfo2 = JSON.parse(AES.decrypt(res2.data.data));
            console.log("输出");
            console.log(aesFecInfo2);
            this.totalItem = aesFecInfo2.medicalInstitution;
            this.total = aesFecInfo2.total2;
            this.tableData = aesFecInfo2.data2;
            this.tableData &&
              this.tableData.map(item => {
                if (item.createTime) {
                  item.createTime = item.createTime.split(" ")[0];
                }
              });

            console.log(this.tableData);

            console.log("获取成功");
          } else {
            this.$message.error("获取数据失败");
          }
        })
        .catch(res => {});
    },
    //图片回显
    getUrl(url) {
      this.img = "";
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.img = aesFecInfo.message;
          }
        })
        .catch(() => {});
    },

    //多选
    duoxuan(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    //排序
    changeTableSort(custom) {
      console.log(custom.order);
      if (custom.order === "ascending") {
        this.tableData = this.tableData.sort((a, b) => a["d"] - b["d"]);
      } else {
        this.tableData = this.tableData.sort((a, b) => b["d"] - a["d"]);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getlist1();
    },
    peopleView() {
      this.$router.push({
        path: "/administratorsOnlyMedicalListStaffManagement",
        name: "administratorsOnlyMedicalListStaffManagement",
        params: {
          medicalId: this.medicalId
        }
      });
    },
    //分页条数
    handleCommand(command) {
      if (command === "a") {
        this.tableSize = 5;
      } else if (command === "b") {
        this.tableSize = 10;
      } else {
        this.tableSize = 15;
      }
      this.currentPage = 1;
      this.getlist1();
    },
    // 收藏
    async collectionInserts() {
      const res = await collectionInsert({
        systemTypeId: 0,
        systemEventId: this.$route.query.medicalId
      });
      console.log(res);
      if (res.data.code === "A0000") {
        this.$message({
          message: this.$t("collectionSuccess"),
          type: "success"
        });
      }
    },
    // 编辑跳转页面
    toEdit() {
      this.$router.push({
        path: "/medicalCertificationModification",
        query: { name: "" }
      });
    }
  }
};
</script>
<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0 10px;
  box-sizing: border-box;
}
.main-box-css {
  display: flex;
  height: 680px;
  padding: 30px 0 0 20px;
  background: #fff;
  justify-content: center;
}
.main-box-all-css {
  width: 100%;
  margin: 0 auto;
}
.left-box {
  width: 484px;
  height: 100%;
  background: #fff;
}
.one-line {
  height: 160px;
  display: flex;
}
.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}
.avatar img {
  width: 150px;
  height: 150px;
}
.institution-name {
  height: 150px;
  flex: 1;
}
.institution-box {
  width: 300px;
  height: 57px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-left: 35px;
  position: relative;
  margin-top: 70px;
  float: left;
}
.institution-title {
  background: #fc630c;
  border-radius: 4px;
  height: 16px;
  width: 49px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: -22px;
  right: 0;
}
.institution-box span {
  position: absolute;
  display: inline-block;
  padding: 0 5px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  background: #ffffff;
}
.institution-main {
  margin-top: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  width: 100%;
  overflow: hidden;
  height: 27px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.two-line {
  height: 50px;
  margin-top: 15px;
  display: flex;
}
.small-input-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.small-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.small-box-title {
  margin-top: 12px;
  padding-left: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.big-input-box {
  width: 290px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}
.big-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.big-input-box /deep/ .el-input {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}
.big-input-box /deep/ .el-input__inner {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}
.inline-box-dropdown {
  height: 38px;
  width: 180px;
  margin-top: 2px;
  margin-left: 10px;
}
.inline-box-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 180px;
}
.inline-box-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 170px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.inline-box-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.small-dropdown {
  width: 143px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}
.small-dropdown span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.small-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 110px;
}
.small-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 110px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.small-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.inline-box-dropdown1 {
  height: 38px;
  width: 110px;
  margin-top: 2px;
  margin-left: 10px;
}
.textarea-line {
  margin-top: 15px;
  width: 484px;
  height: 180px;
}
.textarea-line-box {
  width: 484px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.textarea-line-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.right-box {
  width: 49%;
  height: 100%;
  margin-left: 50px;
  padding-top: 70px;
  box-sizing: border-box;
}

.right-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  text-align: center;
}
.right-box .empty {
  height: 30px;
}
.right-box /deep/ .cell {
  text-align: center;
}
.right-box /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: 20px;
}
.empty-ps {
  position: relative;
}
.pagination-table {
  display: flex;
  height: 40px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.25px;
  color: #454d59;
  margin-top: 10px;
  align-items: center;
  justify-content: right;
}
.pagination-table /deep/ .el-dropdown {
  background: #ffffff;
  width: 60px;
  line-height: 24px;
  height: 24px;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  margin-left: 10px;
}
.pagination-table /deep/ .el-dropdown-link {
  width: 60px;
  height: 24px;
  padding-left: 10px;
  box-sizing: border-box;
  display: inline-block;
}
.pagination-table /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 24px;
  margin-right: 5px;
}
.pagination {
  margin-top: 10px;
}
.per-page {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.main-button-box {
  text-align: center;
  width: 500px;
  margin-top: 20px;
}
.main-button-box button {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.textarea-css-main {
  width: 99%;
  height: 99%;
  margin-left: 1px;
  margin-top: 1px;
  border-radius: 8px;
  padding: 15px 5px 5px 20px;
  box-sizing: border-box;
}
.table-img-css {
  border-radius: 50%;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorsViewMedicalInstitutionsClickDetails/index.vue